/* ------------------------------------------ GRYFF FONT PICKER - T 08.09.2016 ----------------------------------------- */
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import HELPER from '@/app/utils/HELPER';
import throttle from '@/app/utils/throttle';
(function (jQuery) {
  jQuery.gfRangePicker = function (element, options) {
    const defaults = {
      title: '',
      onSelected: function (value) {},
      onSelectedStop: function (value) {},
      onHistoryAdded: function () {},
    };

    const _dataValue = [];

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    let runnerChangeValue = null;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();
      _this.setTemplate();

      $element.on('value-change', function () {
        let value = jQuery(this).val();
        value = HELPER.convertToValueAndUnit(value);

        _this.setValue(value.value);
      });
    };

    this.setTemplate = function () {
      const min = typeof $element.attr('min') === 'undefined' ? 0 : parseFloat($element.attr('min'));
      const max = typeof $element.attr('max') === 'undefined' ? 1 : parseFloat($element.attr('max'));
      const warn_gt = typeof $element.attr('warn_gt') === 'undefined' ? 1 : parseFloat($element.attr('warn_gt'));
      const warn_text = typeof $element.attr('warn_text') === 'undefined' ? '' : $element.attr('warn_text');
      const value = parseFloat($element.val()) > min ? parseFloat($element.val()) : min;

      const step = typeof $element.attr('step') === 'undefined' ? 1 : parseFloat($element.attr('step'));
      const unit = typeof $element.attr('unit') === 'undefined' ? '' : $element.attr('unit');

      const desc = typeof $element.attr('data-description') === 'undefined' ? '' : $element.attr('data-description');
      let _template = '<div class="gfRangePicker">';
      _template += '<div class="gfSGSubTitle">' + _this.settings.title + '</div>';
      _template += '<div class="gfSGclear"></div>';
      if (unit == '') {
        _template += '<div class="gfRangePickerScoll" data-unit="none"><p></p></div>';
        _template +=
          '<div class="gfRangePickerText" data-unit="none"><input type="number" class="gf_remove-spin-button"/>';
      } else {
        _template += '<div class="gfRangePickerScoll"><p></p></div>';
        _template +=
          '<div class="gfRangePickerText"><input type="number" step="' + step + '" class="gf_remove-spin-button"/>';
      }
      if (unit !== 'none') {
        _template += '<span>' + unit + '</span>';
      }
      _template += '</div>';
      _template += '<div class="gfDesc">' + desc + '</div>';
      _template += '</div>';
      $element.after(_template);

      const $gfRangePicker = $element.next();
      const $rangePickerScoll = $gfRangePicker.find('.gfRangePickerScoll');
      const $rangePickerText = $gfRangePicker.find('.gfRangePickerText input');

      _this.setValue(value);

      $rangePickerScoll.slider({
        value: value,
        warn_gt: warn_gt,
        min: min,
        max: max,
        step: step,
        start: function (event, ui) {
          $gfLeftSideBar.focus();
          $gfLeftSideBar.off('mouseup');
        },
        slide: function (event, ui) {
          _this.onChangeValue(ui.value, 'change');

          if (!$element.hasClass('stop-update')) {
            if (checkKeyValid('throttleTriggerInputChange')) {
              _this.throttleTriggerInputChange($element);
            } else {
              setTimeout(function () {
                $element.trigger('range-change').trigger('input-change');
              }, 50);
            }
          }
        },
        stop: function (event, ui) {
          const value = _this.onChangeValue(ui.value, 'change');
          _this.settings.onSelectedStop(value);
          if ($element.hasClass('stop-update')) {
            if (checkKeyValid('throttleTriggerInputChange')) {
              _this.throttleTriggerInputChange($element);
            } else {
              setTimeout(function () {
                $element.trigger('range-change').trigger('input-change');
              }, 50);
            }
          }
          if (warn_gt < value) {
            $('.gfWarningText').remove();
            _template = '<div class="gfWarningText">' + warn_text + '</div>';
            $gfRangePicker.after(_template);
          } else {
            $('.gfWarningText').remove();
          }
          _this.settings.onHistoryAdded();
          $element.trigger('history-change');
        },
      });

      // var delayType;
      $rangePickerText.off('keyup paste').on('keyup paste', function () {
        runnerChangeValue && clearTimeout(runnerChangeValue);
        runnerChangeValue = setTimeout(() => {
          const value = $rangePickerText.val();
          if (value !== '') {
            _this.onChangeValue(value, 'change');
            $element.trigger('range-stop').trigger('input-change');
          }
        }, 600);
      });

      $rangePickerText.focusout(function () {
        let value = $rangePickerText.val();
        if (value === '' || value == 'auto') {
          value =
            typeof $element.attr('default_value') === 'undefined' ? 0 : parseFloat($element.attr('default_value'));
          _this.onChangeValue(value, 'change');
          $element.trigger('range-stop').trigger('input-change');
        }
      });

      // HISTORY OPTIMIZE
      let merOldBackupSettings;
      let merOldBackupDesignOptions;

      const inputName = $element.attr('name');
      const inputId = $element.attr('id');

      $rangePickerText.focus(function () {
        const $this = jQuery(this);
        window._isHistoryEditing = true;
        const oldValue = $element.attr('value');
        const currentTab = $gfLeftSideBar.find('.simple-tabs').data('gftabs').getCurrentTab();
        switch (currentTab) {
          case 'Settings':
            setTimeout(function () {
              merOldBackupSettings = $gryffEditor.data('gfhistory').setMERBackupSettings();
            }, 51);
            $gryffBody.off('mousedown.history.rangepicker').on('mousedown.history.rangepicker', function (e) {
              const $target = jQuery(e.target);

              if (!$target.is($this)) {
                if (oldValue != $element.attr('value')) {
                  const extra = {
                    flagBKSettings: true,
                  };

                  $element.trigger('history-change', extra);
                }
                window._isHistoryEditing = false;
                $gryffBody.off('mousedown.history.rangepicker');
                jQuery('body').off('mousedown.history.rangepicker');
              }
            });

            jQuery('body')
              .off('mousedown.history.rangepicker')
              .on('mousedown.history.rangepicker', function (e) {
                const $target = jQuery(e.target);

                if (!$target.is($this)) {
                  if (oldValue != $element.attr('value')) {
                    const extra = {
                      flagBKSettings: true,
                    };

                    $element.trigger('history-change', extra);
                  }
                  window._isHistoryEditing = false;
                  $gryffBody.off('mousedown.history.rangepicker');
                  jQuery('body').off('mousedown.history.rangepicker');
                }
              });
            break;

          case 'Design':
            setTimeout(function () {
              merOldBackupDesignOptions = $gryffEditor.data('gfhistory').setMERBackupDesignOptions();
            }, 51);

            $gryffBody.off('mousedown.history.rangepicker').on('mousedown.history.rangepicker', function (e) {
              const $target = jQuery(e.target);

              if (!$target.is($this)) {
                if (oldValue != $element.attr('value')) {
                  const extra = {
                    flagBKDesignOptions: true,
                  };
                  _this.settings.onHistoryAdded();
                  $element.trigger('history-change', extra);
                }
                window._isHistoryEditing = false;
                $gryffBody.off('mousedown.history.rangepicker');
                jQuery('body').off('mousedown.history.rangepicker');
              }
            });

            jQuery('body')
              .off('mousedown.history.rangepicker')
              .on('mousedown.history.rangepicker', function (e) {
                const $target = jQuery(e.target);

                if (!$target.is($this)) {
                  if (oldValue != $element.attr('value')) {
                    const extra = {
                      flagBKDesignOptions: true,
                    };
                    _this.settings.onHistoryAdded();
                    $element.trigger('history-change', extra);
                  }
                  window._isHistoryEditing = false;
                  $gryffBody.off('mousedown.history.rangepicker');
                  jQuery('body').off('mousedown.history.rangepicker');
                }
              });
            break;
        }
      });
    };

    this.throttleTriggerInputChange = throttle(function ($this) {
      $this.trigger('range-change').trigger('input-change');
    }, 50);

    this.setValue = function (value) {
      _this.onChangeValue(value);
      return false;
    };

    this.onChangeValue = function (value, type) {
      const $gfRangePicker = $element.next();
      const $rangePickerScoll = $gfRangePicker.find('.gfRangePickerScoll span');
      const $rangePickerText = $gfRangePicker.find('.gfRangePickerText input');

      const max = typeof $element.attr('max') === 'undefined' ? 1 : parseFloat($element.attr('max'));
      const min = typeof $element.attr('min') === 'undefined' ? 0 : parseFloat($element.attr('min'));
      if (value === '' || value == 'auto') {
        $rangePickerText.val(value);
        value = min;
      } else {
        if (value[value.length - 1] !== '.') {
          value = Math.round(parseFloat(value) * 100) / 100;
        }
        //thả cửa trường hợp value lớn hơn max (vì vẫn có trường hợp khách muốn lớn hơn max. Nhỏ hơn min thì hiếm :D)
        if (parseFloat(value) < parseFloat(min)) {
          value = min;
        }
        $rangePickerText.val(value);
      }

      // var percentage = Math.abs(value - min);
      const percentage = value - min;
      const distance = Math.abs(max - min);
      let left = (percentage / distance) * 100;
      if (left > 100) {
        left = 100;
      } else if (left < 0) {
        left = 0;
      }
      $rangePickerScoll.css({
        left: left + '%',
      });

      if ($element.attr('unit')) {
        $element.attr('value', value + $element.attr('unit')).val(value + $element.attr('unit'));
        if (type == 'change') {
          _this.settings.onSelected(value + $element.attr('unit'));
        }
        return value + $element.attr('unit');
      } else {
        $element.attr('value', value).val(value);
        if (type == 'change') {
          _this.settings.onSelected(value);
        }
        return value;
      }
    };

    this.setBlock = function () {
      const $iconLock = jQuery(
        '<div class="gfRangePickerIconLock"><svg fill="#FFC439" height="14px" viewBox="0 0 24 24" width="14px" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg></div>',
      );
      const $gfRangePicker = $element.next('.gfRangePicker');
      const $rangePickerTitle = $gfRangePicker.find('.gfSGSubTitle');
      const isLock = $rangePickerTitle.find('.gfRangePickerIconLock').length > 0;
      if (!isLock) {
        $rangePickerTitle.append($iconLock);
      }

      $iconLock.gfTooltipsNew({
        postion: 'top',
        desc: 'You have configured in More settings',
        timeOut: 200,
      });

      $gfRangePicker.find('.gfRangePickerScoll').css({
        opacity: '0.3',
        'pointer-events': 'none',
        left: '0%',
      });
      $gfRangePicker
        .find('.gfRangePickerText')
        .css({
          opacity: '0.3',
          'pointer-events': 'none',
        })
        .val('');
      return false;
    };

    this.setOffBlock = function (value) {
      const $gfRangePicker = $element.next();
      const $rangePickerTitle = $gfRangePicker.find('.gfSGSubTitle');
      const $lockIcon = $rangePickerTitle.find('.gfRangePickerIconLock');
      const isLock = $lockIcon.length > 0;
      if (isLock) {
        $lockIcon.remove();
      }
      $gfRangePicker.find('.gfRangePickerScoll').css({
        opacity: '1',
        'pointer-events': 'auto',
      });
      $gfRangePicker.find('.gfRangePickerText').css({
        opacity: '1',
        'pointer-events': 'auto',
      });
      value = HELPER.convertToValueAndUnit(value);
      _this.setValue(value.value);
    };

    this.init();
  };
  jQuery.fn.gfRangePicker = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfrangepicker')) {
        const plugin = new jQuery.gfRangePicker(this, options);
        jQuery(this).data('gfrangepicker', plugin);
      }
    });
  };
})(jQuery);
